import { Flex, Divider, Box, Text } from '@cad-arc';
import { getCautionsGroupedByCategory } from './helpers';
import { SubPremiseCautionBlock } from './sub-premise-caution-block';
import { CautionPill } from '../../../cautions/components/caution-pill';
import { GeoCautionDto } from '@mark43/rms-api';
import { CommonSize } from '../../../common/helpers/utils';

type LocationCautionsSectionProps = {
    cautions: GeoCautionDto[] | undefined;
    size?: CommonSize;
};

export function LocationCautionsSection({
    cautions,
    size,
}: LocationCautionsSectionProps): React.ReactElement {
    const cautionsGrouped = getCautionsGroupedByCategory(cautions || []);

    const isCautionsGroupedByCategory = cautionsGrouped.byCategory.length > 0;
    const isCautionsGroupedBySubPremise = Object.keys(cautionsGrouped.subPremise).length > 0;

    return (
        <Box>
            <Flex
                direction="column"
                padding="12px 18px"
                data-testid="MAP_LOCATION_PIN_CAUTIONS_SECTION"
            >
                <Box marginBottom={3}>
                    <Text fontSize={size} fontWeight="bold">
                        Cautions
                    </Text>
                </Box>
                {isCautionsGroupedByCategory || isCautionsGroupedBySubPremise ? (
                    <Flex direction="column">
                        {cautionsGrouped.byCategory.map(({ cautions, categoryHeader }) => {
                            return (
                                <Box key={categoryHeader}>
                                    <Text
                                        fontSize={size}
                                        data-testid="MAP_LOCATION_PIN_CAUTIONS_LABEL"
                                    >
                                        {categoryHeader}
                                    </Text>
                                    {cautions.map((caution) => {
                                        return (
                                            <CautionPill
                                                key={caution.id}
                                                caution={caution}
                                                size={size == 'lg' ? 'md' : 'sm'}
                                            />
                                        );
                                    })}
                                </Box>
                            );
                        })}
                        <SubPremiseCautionBlock
                            isCautionsGroupedByCategory={isCautionsGroupedByCategory}
                            subPremiseCautions={cautionsGrouped.subPremise}
                            size={size}
                        />
                    </Flex>
                ) : (
                    <Text data-testid="MAP_LOCATION_NO_CAUTIONS_MESSAGE">
                        {cautions ? 'No Location Cautions Found' : 'Loading cautions...'}
                    </Text>
                )}
            </Flex>
            <Divider />
        </Box>
    );
}
